
/////////////////////////////////////////////////////
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Cookies from "universal-cookie";
import { useState, useEffect } from "react";
import { getKeywords, addKeyword, updateKeyword, deleteKeyword } from "../../actions/keywordsAction";
import { Link } from "react-router-dom";
import { FiTrash2, FiEdit2 } from "react-icons/fi";
import { DELETE, EDIT } from "../../constants/url";
import { Tooltip } from "react-tooltip";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@mui/material";

const Keywords = () => {
  const [keywords, setKeywords] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [keywordId, setKeywordId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadKeywords();
  }, []);

  const loadKeywords = () => {
    getKeywords().then((response) => {
      if (!response.status) {
        console.log(response.msg);
      } else {
        setKeywords(response.data.keywords);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (keywordId) {
      updateKeyword({ keyword }, keywordId)
        .then((response) => {
          if (response && !response.status) {
            showAlert("error", response.msg);
          } else {
            showAlert("success", "Keyword updated successfully");
            loadKeywords();
            handleClose();
          }
        })
        .catch((error) => {
          console.error("Update Keyword Error:", error);
          showAlert("error", "An error occurred while updating keyword");
        });
    } else {
      addKeyword({ keyword })
        .then((response) => {
          if (response && !response.status) {
            showAlert("error", response.msg);
          } else {
            showAlert("success", "Keyword added successfully");
            loadKeywords();
            handleClose();
          }
        })
        .catch((error) => {
          console.error("Add Keyword Error:", error);
          showAlert("error", "An error occurred while adding keyword");
        });
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteKeyword(id).then((response) => {
          if (!response.status) {
            showAlert("error", response.msg);
          } else {
            showAlert("success", "Keyword deleted successfully");
            loadKeywords();
          }
        });
      }
    });
  };

  const showAlert = (type, message) => {
    Swal.fire({
      title: message,
      icon: type,
      confirmButtonText: "Okay",
    });
  };

  const handleEdit = (keyword) => {
    setKeyword(keyword.keyword);
    setKeywordId(keyword._id);
    setShowModal(true);
  };

  const handleClose = () => {
    setKeyword("");
    setKeywordId(null);
    setShowModal(false);
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link href="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Keywords</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Keywords</h4>
                </div>
              </div>
            </div>
            <Dialog
              open={showModal}
              onClose={handleClose}
              sx={{ '& .MuiDialog-paper': { width: '60%', maxWidth: '60%' } }}
            >
              <DialogTitle>{keywordId ? "Edit Keyword" : "Add Keyword"}</DialogTitle>
              <DialogContent>
                <form onSubmit={handleSubmit}>
                  <TextField
                    label="Keyword"
                    fullWidth
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    required
                  />
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} variant="outlined"
                  color="error" sx={{ mt: 2, mr: 1 }}
                >
                  Cancel
                </Button>
                <Button onClick={handleSubmit} type="submit"
                  variant="contained"
                  color="success"
                  sx={{ mt: 2 }}
                  style={{ backgroundColor: "#769A0F" }}>
                  {keywordId ? "Update" : "Submit"}
                </Button>
              </DialogActions>
            </Dialog>

            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setShowModal(true)}
                    style={{ marginBottom: "16px", backgroundColor: '#769A0F', borderColor: '#769A0F', color: '#FFFFFF' }}
                  >
                    <i className="fa fa-plus"></i> Add Keyword
                  </Button>
                  <div style={{ width: "98%" }}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">S.No</TableCell>
                            <TableCell align="center">Keyword</TableCell>
                            <TableCell align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {keywords.length === 0 ? (
                            <TableRow>
                              <TableCell style={{ width: "20%" }} align="center"></TableCell>
                              <TableCell style={{ width: "50%" }} align="center">No Keywords Found</TableCell>
                              <TableCell style={{ width: "30%" }} align="center"></TableCell>
                            </TableRow>
                          ) : (
                            keywords.map((keyword, index) => (
                              <TableRow key={keyword._id}>
                                <TableCell align="center">{index + 1}</TableCell>
                                <TableCell align="center">{keyword.keyword}</TableCell>
                                <TableCell align="center">
                                  <i    
                                  className="mr-2 cursor-pointer"             
                                  data-tooltip-id="1"
                                  data-tooltip-content={`${EDIT}`}                    
                                  onClick={() => handleEdit(keyword)}
                                  >
                                  <FiEdit2 size="18px" color="#0978F2"
                                  />
                                  </i>
                                  <i
                                  className="ml-2 cursor-pointer"
                                  data-tooltip-id="2"
                                  data-tooltip-content={`${DELETE}`}
                                  onClick={() => handleDelete(keyword._id)}

                                  >
                                  <FiTrash2 size="18px" color="red"
                                  />
                                  </i>
                                   <Tooltip id="1" />
                                   <Tooltip id="2" />
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Keywords;
